import { AuthorizationService } from '@app/services/authorization.service';

export interface MenuRoute {
  path: string;
  permissionCheck: (auth: AuthorizationService) => boolean;
}

export const USER_MENU_ROUTES: MenuRoute[] = [
  { path: '/user/tasks', permissionCheck: (auth) => auth.hasPermissionSection('tasks') },
  { path: '/user/transaction-history', permissionCheck: (auth) => auth.hasPermission('transaction:view') },
  { path: '/user/memorial-orders', permissionCheck: (auth) => auth.hasPermission('memorialorder:view') },
  { path: '/user/accounts', permissionCheck: (auth) => auth.hasPermissionSection('accounts') },
  { path: '/user/groups', permissionCheck: (auth) => auth.hasPermission('groups:view') },
  { path: '/user/operations', permissionCheck: (auth) => auth.hasPermissionSection('cash desk') },
  { path: '/user/exchange', permissionCheck: (auth) => auth.hasPermission('currency:exchange:view') || auth.hasPermission('currency:view') },
  { path: '/user/loans', permissionCheck: (auth) => auth.hasPermission('loanTemplate:view') },
  { path: '/user/operations-day', permissionCheck: (auth) => auth.hasPermission('banking:day:change') },
  { path: '/user/jobs', permissionCheck: (auth) => auth.hasPermission('job:view') },
];